export const PAGINATION_PAGE_SIZE = 20;

export const DEFAULT_PAGINATION_OPTIONS = {
  defaultPageSize: PAGINATION_PAGE_SIZE,
  showSizeChanger: true,
  pageSizeOptions: ["20", "50", "100"],
  showTotal: (total) => `Total ${total} items`,
};

export const shouldShowPagination = (total) => {
  const count = Array.isArray(total) ? total.length : Number(total) || 0;
  return count > PAGINATION_PAGE_SIZE;
};

export const buildConditionalPagination = (total, options = {}) => {
  if (!shouldShowPagination(total)) {
    return false;
  }

  return {
    ...DEFAULT_PAGINATION_OPTIONS,
    ...options,
  };
};
